// extracted by mini-css-extract-plugin
export default {"container":"Currency_container__HUSuj","about__sectionTitle":"Currency_about__sectionTitle__Sq5Y-"};